import * as React from "react";
import { BaseFieldEditor } from "./helper";
import { FieldValueText } from "typings";
import { Icon } from "office-ui-fabric-react";

export interface Props extends BaseFieldEditor
{
    value: FieldValueText;
}


class Url extends React.Component<Props>
{
    render()
    {
        return <Icon iconName="FiLink"></Icon>;
    }
}

export default Url;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Url.tsx